import axios from 'axios'
axios.defaults.headers['Accept'] = 'application/json'
axios.defaults.headers['Content-Type'] = 'application/json'
import { AssertApi } from '@/api/market'
import { getCurDate } from '@/utils/dateutils'

// 获得储值卡
export function refreshAssert() {
    axios.get(AssertApi).then((ret) => {
        if (ret.flag) {
            ret = ret.details
            const data = {
                packages: ret.packages,
                coupons: ret.coupons,
                store_card: ret.store_card,
                vouchers: ret.vouchers
            }
            localStorage.setItem('assert', JSON.stringify(data))
        } else {
            localStorage.removeItem('assert')
        }
    })
}

// 获得储值卡
export function getAvailableStoreCard() {
    const assert = localStorage.getItem('assert')
    if (assert != null) {
        const data = JSON.parse(assert)
        if (data !=null && data.store_card != null) {
            const curDate = getCurDate()
            const store_card = data.store_card
            if (store_card.state 
                && store_card.begin_date <= curDate 
                && store_card.end_date >= curDate 
                && store_card.amount_available>0) {
                    return store_card
                }
            else {
                return null
            }
        }
    }
}